var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "home-page-container", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { staticClass: "admin-header", attrs: { xs12: "" } },
        [
          _c("v-flex", { attrs: { "ml-4": "" } }, [
            _c("span", { staticStyle: { "font-size": "20px" } }, [
              _vm._v("Setup and Configure"),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "" } },
            [
              _c(
                "v-container",
                _vm._b(
                  { attrs: { fluid: "" } },
                  "v-container",
                  { [`grid-list-xl`]: true },
                  false
                ),
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", xs12: "" } },
                    _vm._l(_vm.pageMenuItems, function (item, i) {
                      return _c(
                        "v-flex",
                        { key: i, attrs: { xs4: "" } },
                        [
                          !item.suOnly
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "panelBackground",
                                  staticStyle: {
                                    border: "1px solid #9B9B9B",
                                    cursor: "pointer",
                                    width: "140px",
                                    height: "140px",
                                  },
                                  attrs: { flat: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.navigate(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "linkIcon" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "30",
                                                color: "var(--default-color)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.icon) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "caption font-weight-bold",
                                          staticStyle: {
                                            color: "var(--soft-text-color)",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.title))]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs4: "" } },
            [
              _vm.isSU
                ? _c(
                    "v-container",
                    _vm._b(
                      { attrs: { fluid: "" } },
                      "v-container",
                      { [`grid-list-xl`]: true },
                      false
                    ),
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", xs12: "" } },
                        _vm._l(_vm.pageMenuSuItems, function (item, i) {
                          return _c(
                            "v-flex",
                            { key: i, attrs: { xs6: "" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "panelBackground",
                                  staticStyle: {
                                    border: "1px solid #9B9B9B",
                                    cursor: "pointer",
                                    width: "140px",
                                    height: "140px",
                                  },
                                  attrs: { flat: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.navigate(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "linkIcon" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "30",
                                                color:
                                                  "var(--secondary-btn-color)",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.icon))]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "caption font-weight-bold",
                                            staticStyle: {
                                              color: "var(--soft-text-color)",
                                              "margin-bottom": "0px",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.title))]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }